import React, { FC } from 'react'

import { Hit } from 'pages/frequent-questions/types/FrequentQuestions.types'

import { QuestionsContainer } from './styles'
import { QuestionSkeleton } from '../question-skeleton'
import { FaqCard } from '../faq-card'
import { NoResultsFound, NoResultsFoundProps } from '../faq-no-results-found'

type FaqContentProps = {
  isFaqLoading: boolean
  showMore: boolean
  queryText: string
  isTyping: boolean
  noResultsFound: NoResultsFoundProps
  faqs?: Hit[]
}

export const FaqContent: FC<FaqContentProps> = ({
  isFaqLoading,
  showMore,
  queryText,
  isTyping,
  noResultsFound,
  faqs,
}) => {
  if (isFaqLoading || isTyping) return <QuestionSkeleton />

  if (queryText && faqs && faqs?.length === 0) return <NoResultsFound {...noResultsFound} />

  if (faqs && faqs.length > 0)
    return (
      <QuestionsContainer className={showMore ? 'expanded' : 'collapsed'}>
        {faqs?.map((hit: Hit) => (
          <FaqCard key={hit.id} id={hit.id} question={hit.fields.title} />
        ))}
      </QuestionsContainer>
    )

  return null
}
